module.exports = __webpack_public_path__ + "img/icon_anonbud_sameschool.69797648.svg";